import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { ADMIN_URL_V2, ADMIN_WORKSPACE_URL_V2 } from '../constants';

import {
  ConfigSubmissionsData,
  DocumentAttribute,
  DocumentTypes,
  IrisMapping,
  IrisRoutingGroupData,
  SDocumentPayload,
  SubmissionDocument,
} from '../types';

import environment from '../../../../environments/environment';

@Injectable()
export class SubmissionService {
  private readonly _http = inject(HttpClient);

  getIrisRoutingGroups() {
    const _url = `${ADMIN_URL_V2}/routing_groups/`;
    return this._http.get<IrisRoutingGroupData>(_url);
  }

  getSubmissionTypeIrisMapping(
    workspaceTypeId: string,
    entity_type: string,
  ): Observable<IrisMapping> {
    const url = `${ADMIN_WORKSPACE_URL_V2}${workspaceTypeId}/?entity_type=${entity_type}`;
    return this._http
      .get<SubmissionDocument>(url)
      .pipe(map((res) => res.iris_mapping));
  }

  updateSubmissionTypeIrisMapping(
    workspaceTypeId: string,
    entity_type: string,
    irisMapping: IrisMapping,
  ) {
    const url = `${ADMIN_WORKSPACE_URL_V2}${workspaceTypeId}/`;
    return this._http.put(url, {
      entity_type: entity_type,
      iris_mapping: irisMapping,
    });
  }

  getAllAttributes(params: HttpParams) {
    const url = `${environment.irisApi}/document/attribute-type/`;
    return this._http.get<DocumentAttribute>(url, {
      params: params,
    });
  }

  getSubmissionDocumentTypes(): Observable<DocumentTypes> {
    const url = `${environment.irisApi}/v2/document/type/`;
    return this._http.get<DocumentTypes>(url);
  }

  getSubmissionDocumentTypeList(
    data: ConfigSubmissionsData,
  ): Observable<SubmissionDocument> {
    const url = `${ADMIN_WORKSPACE_URL_V2}${data.id}/?entity_type=${data.entity_type}`;
    return this._http.get<SubmissionDocument>(url);
  }

  updateSubmissionDocumentTypes(data: SDocumentPayload) {
    const url = `${ADMIN_WORKSPACE_URL_V2}${data.submissionId}/document_type/`;
    return this._http.put(url, {
      data: data.payload,
      entity_type: data.entityType,
    });
  }
}
